import * as React from 'react';
import * as ReactDOM from 'react-dom';

import './styles/app.scss';
import App from './App';

const container = document.getElementById('app');
ReactDOM.render(<App />, container);
